import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  container({ container_id }) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/edit_packages/container/${container_id}`
    );
  },
  fetchPackages(container_id, producer_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/edit_packages/${container_id}/fetch_packages/p/${producer_id}/o/${organization_id}`
    );
  },
  updatePackages(container_id, packages) {
    return RequesterV1.post(
      `agro_exporter/production/uniq_final_packing_list/edit_packages/container/${container_id}/update`,
      { packages: packages }
    );
  },
  fetchExportProcessCropCategories(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/edit_packages/list_exporter_process_crop_categories/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessCropVarieties(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/edit_packages/list_exporter_process_crop_varieties/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessCropSizes(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/edit_packages/list_exporter_process_crop_sizes/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessBrands(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/edit_packages/list_exporter_process_brands/${agro_exporter_process_id}/${container_id}`
    );
  },
  fetchExportProcessCropPackages(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/edit_packages/list_exporter_process_crop_packages/" +
        agro_exporter_process_id
    );
  },
  fetchPackageGroups(container_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/edit_packages/list_package_groups/" +
        container_id
    );
  },
  fetchProducersOrganizations() {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/edit_packages/list_producers_organizations"
    );
  }
};
